import script from "./[id].vue?vue&type=script&setup=true&lang=ts"
export * from "./[id].vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=5ccf4a60&scoped=true&lang=css&external"
import "./[id].vue?vue&type=style&index=1&id=5ccf4a60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ccf4a60"]])

export default __exports__